import { inject, Injectable } from '@angular/core';
import { ProductsService } from '@services/products.service';
import { ProductsStore } from '@services/products.store';
import { FilterOptionsContext, groupOptionsByTenant, SourceFilterOptionsLoader } from '@shared/dataview/options/filter-options.registry';
import { SelectListItem } from '@shared/models/select-list-item';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProductNdcsOptionsLoader extends SourceFilterOptionsLoader {
  readonly source = 'productNdcs';

  private readonly productsService = inject(ProductsService);
  private readonly productsStore = inject(ProductsStore);

  load(_def: unknown, context: FilterOptionsContext): Observable<SelectListItem[]> {
    return this.productsStore.getAll().pipe(
      map(productsByTenant =>
        Object.keys(productsByTenant)
          .sort((a, b) => a.localeCompare(b))
          .flatMap(tenantId => groupOptionsByTenant(this.productsService.mapSelectList(productsByTenant[tenantId]), tenantId, context)),
      ),
    );
  }
}
